<template>
  <div>
    <BarChart :chartData="servicos" :options="options" />
  </div>
</template>

<script>
import BarChart from '@/components/Charts/__BarChart'
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    BarChart,
  },
  data() {
    return {
      options: {
        responsive: true,
      },
    }
  },
  computed: {
    servicos() {
      if (Object.keys(this.data).length > 0) {
        const chartData = {
          labels: [],
          datasets: [],
        }
        chartData.labels = Object.values(this.data).map((item) => item.mes)
        chartData.datasets = [
          {
            label: 'Agendados',
            backgroundColor: '#57b757',
            data: Object.values(this.data).map((item) => item.servicos.triados),
          },
          {
            label: 'Cancelados',
            backgroundColor: '#f87979',
            data: Object.values(this.data).map(
              (item) => item.servicos.cancelados
            ),
          },
        ]
        return chartData
      }
      return {}
    },
  },
  methods: {},
}
</script>
